module.exports = __webpack_public_path__ + "img/question17c4.49193ad7.png";